import router from '../router';

//根据页面获取控制权限
export const getControll = (index) => {
	//加载控制权限
	let controllsJson = eval('(' +localStorage.getItem('ms_controlls') + ')');
	let currentControll = controllsJson[index];
	if (currentControll == undefined) {
		router.push('/403');
		throw "无权限";
	}
	return currentControll;
}